import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import logoM from "@/assets/logo_m.png.asset.json";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Mine Class | Capacitación para Empresas Mineras" },
      { name: "description", content: "Optimiza la capacitación de la dotación minera con Mine Class. LMS móvil, cursos corporativos y tecnología con IA para la gestión de personas en faena." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: PreLanding,
});

function PreLanding() {
  const router = useRouter();
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    // Prefetch /home so it's ready when we transition
    router.preloadRoute({ to: "/home" }).catch(() => {});

    const fadeOut = setTimeout(() => setLeaving(true), 500);
    const nav = setTimeout(() => {
      router.navigate({ to: "/home", replace: true });
    }, 900);

    return () => {
      clearTimeout(fadeOut);
      clearTimeout(nav);
    };
  }, [router]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-white transition-opacity duration-400 ease-out"
      style={{ opacity: leaving ? 0 : 1 }}
    >
      <div className="relative w-40 h-40 flex items-center justify-center">
        <img
          src={logoM.url}
          alt="Mine Class"
          className="w-24 h-24 object-contain relative z-10 animate-[fade-in_0.5s_ease-out]"
        />
        <div
          className="absolute inset-0 rounded-full border-2 border-transparent border-t-[var(--color-brand-coral)] animate-spin"
          style={{ animationDuration: "0.9s" }}
        />
      </div>
    </div>
  );
}
